export const iconFontAwesomeAccessibilityWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
